import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { SharedModule } from './shared/shared.module';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { AuthenticationService } from './core/modules/auth-core/data/service/authentication.service';
import { AppSettings } from './core/configs/app.settings';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    CoreModule,
    SharedModule,
    GoogleTagManagerModule.forRoot({
     id: AppSettings.gtmId
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    OneSignal,
    AuthenticationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
